class StickyScroll extends HTMLElement {
  constructor() {
    super();
    this.BOTTOM_OFFSET = 50;
    this.TOP_OFFSET = 100; // New top offset
    this.scroll = this.scroll.bind(this);
    this.requestScroll = this.requestScroll.bind(this);
    this.handleCartDrawerToggle = this.handleCartDrawerToggle.bind(this);
  }

  connectedCallback() {
    this.resetState();
    window.addEventListener('scroll', this.requestScroll);
    document.addEventListener('on:cart-drawer:after-open', this.handleCartDrawerToggle);
    document.addEventListener('on:cart-drawer:after-close', this.handleCartDrawerToggle);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.requestScroll);
    document.removeEventListener('on:cart-drawer:after-open', this.handleCartDrawerToggle);
    document.removeEventListener('on:cart-drawer:after-close', this.handleCartDrawerToggle);
  }

  resetState() {
    this.previousY = window.scrollY;
    this.initialTop = Math.max(0, parseFloat(window.getComputedStyle(this).top) || 0);
    this.currentTop = this.initialTop;
    this.ticking = false;
  }

  requestScroll() {
    if (!this.ticking) {
      requestAnimationFrame(() => {
        this.scroll();
        this.ticking = false;
      });
      this.ticking = true;
    }
  }

  get maxTop() {
    return this.TOP_OFFSET;
  }

  get minTop() {
    return Math.min(0, window.innerHeight - this.clientHeight - this.BOTTOM_OFFSET);
  }

  scroll() {
    const currentScrollY = window.scrollY;
    const scrollingDown = currentScrollY > this.previousY;
    
    if (scrollingDown) {
      // Scrolling down: move towards bottom
      this.currentTop = Math.max(this.minTop, this.currentTop - (currentScrollY - this.previousY));
    } else {
      // Scrolling up: move towards top
      this.currentTop = Math.min(this.maxTop, this.currentTop + (this.previousY - currentScrollY));
    }

    this.previousY = currentScrollY;
    this.style.top = `${this.currentTop}px`;
  }

  handleCartDrawerToggle() {
    this.resetState();
    this.requestScroll();
  }
}

customElements.define('sticky-scroll', StickyScroll);